/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import { CTitle, STitle, TTitle } from '../../components/Widget';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import arrow from '../../../../../../assets/2025/arrow.gif';
import person from '../../../../../../assets/finance/topic1400/importance/person.png';
import importanceCode1 from '../../../../../../assets/finance/topic1400/importance/code1.png';
import importanceCode2 from '../../../../../../assets/finance/topic1400/importance/code2.png';
import importanceCode3 from '../../../../../../assets/finance/topic1400/importance/code3.png';
import importanceCode4 from '../../../../../../assets/finance/topic1400/importance/code4.png';
import { useUpdateComponentState } from '../../../hooks';
import QRightBg from "../../../../../../assets/finance/topic1400/q_right_bg.png";
import link1 from '../../../../../../assets/finance/topic1400/tampering/code1.png';
import link2 from '../../../../../../assets/finance/topic1400/tampering/code2.png';
import link3 from '../../../../../../assets/finance/topic1400/tampering/code3.png';
import link4 from '../../../../../../assets/finance/topic1400/tampering/code4.png';
import play from '../../../../../../assets/finance/topic900/link/play.png';
import { Modal } from 'antd';

const IMPORTANCE_IMAGES: Record<number, string> = {
  1: importanceCode1,
  2: importanceCode2,
  3: importanceCode3,
  4: importanceCode4,
};

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const [state, setState] = useState({
    play: 1,
    factorPlay: 1,
    isFactorPlayed: false,
  });
  const tabItems = paragraphsSettings?.tabsList ?? [];
  const lastTabCode = tabItems.length
    ? tabItems[tabItems.length - 1].code
    : undefined;

  const [active, setActive] = useState<number>(() => tabItems[0]?.code ?? 1);
  const [switchTab, setSwitchTab] = useState(false);
  const updateComponentState = useUpdateComponentState();

  const [tamperingVisibleCount, setTamperingVisibleCount] = useState(1);
  const [tamperingAnimationStarted, setTamperingAnimationStarted] = useState(false);
  const [tamperingModalOpen, setTamperingModalOpen] = useState(false);
  const [activeTamperingItem, setActiveTamperingItem] = useState<any>(null);

  const linkImageMap: Record<number, string> = {
    1: link1,
    2: link2,
    3: link3,
    4: link4,
  };

  const triggerUpdate = React.useCallback(
    (key: string) => updateComponentState(p_course, p_topic, ID, key),
    [updateComponentState, p_course, p_topic]
  );

  const handleTamperingArrowClick = React.useCallback(() => {
    if (tamperingAnimationStarted) return;
    setTamperingAnimationStarted(true);
    setTamperingVisibleCount(2);
    triggerUpdate('finance-topic1400-section1-2');
  }, [tamperingAnimationStarted, triggerUpdate]);

  React.useEffect(() => {
    if (
      !tamperingAnimationStarted ||
      tamperingVisibleCount >= (paragraphsSettings?.tamperingList?.length ?? 0)
    )
      return;
    const timer = setTimeout(() => setTamperingVisibleCount((v) => v + 1), 600);
    return () => clearTimeout(timer);
  }, [
    tamperingVisibleCount,
    tamperingAnimationStarted,
    paragraphsSettings?.tamperingList?.length,
  ]);

  const handleTamperingCaseClick = (
    e: React.MouseEvent,
    item: any,
    i: number
  ) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveTamperingItem({ ...item, _index: i + 1 });
    setTamperingModalOpen(true);
  };

  const activeTamperingImage =
    linkImageMap[Number(activeTamperingItem?.id)] ||
    linkImageMap[Number(activeTamperingItem?._index)] ||
    link1;

  React.useEffect(() => {
    if (!tabItems.length) return;
    const exists = tabItems.some((t: { code: number }) => t.code === active);
    if (!exists) {
      setActive(tabItems[0].code);
      setSwitchTab(false);
    }
  }, [paragraphsSettings?.tabsList]);


  const importanceImageSrc =
    IMPORTANCE_IMAGES[active] ?? importanceCode1;

  const clickTab = (code: number) => {
    if (lastTabCode === undefined) return;
    if (active === lastTabCode || switchTab) {
      setActive(code);
      return;
    }
    const curIdx = tabItems.findIndex((t: { code: number }) => t.code === active);
    const nextCode =
      curIdx >= 0 ? tabItems[curIdx + 1]?.code : undefined;
    if (code === nextCode) {
      setActive(code);
      if (code === lastTabCode) {
        setSwitchTab(true);
        updateComponentState(
          p_course,
          p_topic,
          ID,
          'finance-topic1400-section1-1'
        );
      }
    }
  };

  const startFactorPlay = (next = 1) => {
    if (state.isFactorPlayed) {
      return;
    }
    next += 1;
    setState({ ...state, factorPlay: next, isFactorPlayed: true });
    if (next <= 5) {
      setTimeout(() => startFactorPlay(next), 500);
    } else {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1400-section1-3'
      );
    }
  };

  interface RiskListProps {
    risks: any[];
    visibleCount: number;
    animationStarted: boolean;
    onClick?: () => void;
    renderItem: (risk: any, index: number) => React.ReactNode;
  }

  const RiskList: React.FC<RiskListProps> = ({
    risks,
    visibleCount,
    animationStarted,
    onClick,
    renderItem,
  }) => (
    <div
      className="left-list"
      onClick={onClick}
      style={{ cursor: onClick && !animationStarted ? 'pointer' : 'default' }}
    >
      {risks?.map((r, i) => (
        <div
          key={i}
          className="risk-item"
          data-show={i < visibleCount}
          style={{ cursor: onClick && !animationStarted ? 'pointer' : 'default' }}
        >
          {renderItem(r, i)}
        </div>
      ))}
    </div>
  );

  const TamperingSection = () => (
    <div className="tampering">
      <STitle title={paragraphsSettings?.tampering} />
      <TTitle title={paragraphsSettings?.tamperingTitle} />
      <div
        className="content"
        id="finance-topic1400-section1-2"
      >
        {!tamperingAnimationStarted && <img className="arrow-img" src={arrow} alt="" />}
        {RiskList({
          risks: paragraphsSettings?.tamperingList,
          visibleCount: tamperingVisibleCount,
          animationStarted: tamperingAnimationStarted,
          onClick: handleTamperingArrowClick,
          renderItem: (r, i) => (
            <>
              <div className="risk-title">
                <span>{r.title}</span>
              </div>
              <div className="risk-desc">
                <div className="risk-desc-box">{r.desc}</div>
                <a
                  className="tampering-case"
                  href="#"
                  onClick={(e) => handleTamperingCaseClick(e, r, i)}
                >
                  {paragraphsSettings?.tamperingCase}
                </a>
              </div>
            </>
          ),
        })}
      </div>
    </div>
  );

  return (
    <div className="topic-section-1">
      <CTitle title={paragraphsSettings?.title} />
      <div className="cycle-overview">
        <div className="cycle-overview-left">{paragraphsSettings?.l1}</div>
        <div className="cycle-overview-right">{paragraphsSettings?.l2}</div>
      </div>
      <STitle title={paragraphsSettings?.tips} />
      <div className="issue-content">
        <div className="issue-content-link">
          <div className="word">{paragraphsSettings?.l3}</div>
          <div>
            <span>{paragraphsSettings?.l6}</span>
            <a className="text" href={'https://www.hk01.com/%E7%AA%81%E7%99%BC/60318465/%E8%AD%A6%E5%8F%8D%E8%A9%90%E9%A8%99%E6%8B%98682%E4%BA%BA%E6%B6%89-6-2%E5%84%84-%E8%A9%90%E9%A8%99%E9%9B%86%E5%9C%98%E8%81%98%E6%B4%97%E9%BB%91%E9%8C%A2%E9%9B%86%E5%9C%98%E6%B4%97%E7%99%BD-4400%E8%90%AC%E9%A8%99%E6%AC%BE'} target="_blank">{paragraphsSettings?.l5}</a>
          </div>
        </div>
        <div className="silder-list">
          {paragraphsSettings?.tipsList?.map((item: any, i: number) => (
            <div className="silder-list-item" key={i}>
              <div className="hexagon">{i + 1}</div>
              <div className="item-left">
                <h3>{item?.title}</h3>
                <p>{item?.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <img className="issue-content-bg" src={QRightBg} alt="" />
      </div>
      <STitle title={paragraphsSettings?.tabsTitle} />
      <div
        className="cybersecurity-importance"
        id="finance-topic1400-section1-1"
      >
        <div className="middle">
          <div className="chat-wrap">
            <p className="chat-text">{tabItems.find((t: { code: number }) => t.code === active)?.tips ?? ''}</p>
          </div>
          <img className="person" src={person} alt="" />
        </div>

        <nav className="tabs">
          {tabItems.map((n: { code: number }, index: number) => (
            <React.Fragment key={n.code}>
              {n.code === active &&
                index < tabItems.length - 1 &&
                !switchTab && (
                  <div
                    className={`arrow-box ${
                      n.code === active ? `active-arrow-box${n.code}` : ''
                    }`}
                    data-active={n.code === active ? 'true' : 'false'}
                  >
                    <img src={ImgPoint} alt="" />
                  </div>
                )}
              <div
                className={`tab ${n.code === active ? 'active' : ''}`}
                onClick={() => clickTab(n.code)}
              >
                {String(n.code).padStart(2, '0')}
              </div>
            </React.Fragment>
          ))}
        </nav>
        <div className="tip">
          <h3>{tabItems.find((t: { code: number }) => t.code === active)?.title ?? ''}</h3>
          <img
            className="importance-tip-img"
            src={importanceImageSrc}
            alt=""
          />
        </div>
      </div>
      {TamperingSection()}
      <STitle title={paragraphsSettings?.l4Title} />
      <div
        className="factor-content"
        id="finance-topic1400-section1-3"
        onClick={() => startFactorPlay()}
      >
        {state.factorPlay <= 1 && (
          <img src={ImgPoint} alt="" className="img-point" />
        )}
        <div className="factor-tips">{paragraphsSettings?.l4Tip}</div>
        {paragraphsSettings?.l4?.map((item: string, i: number) => (
          <div
            className={`factor-item factor-item-${i + 1} ${
              state.factorPlay > i ? 'box-fade-right-in' : ''
            }`}
            key={i}
          >
            <span>{item}</span>
          </div>
        ))}
      </div>
      <Modal
        title=""
        width="68%"
        getContainer={false}
        open={tamperingModalOpen}
        onCancel={() => setTamperingModalOpen(false)}
        footer={null}
        wrapClassName="section2-link-modal"
      >
        <div className="news-card">
          <div className="news-header">
            <img src={play} className="news-header-play" alt="" />
            {activeTamperingItem?.linkTitle || ''}
          </div>
          <div className="news-content">
            <img
              className="news-image"
              src={activeTamperingImage}
              alt={activeTamperingItem?.linkTitle || 'case image'}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Section1;
